import {
  StandardContainer,
  useWidgetState,
  Selectors,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useFocusEffect} from '@react-navigation/native';
import {View} from 'native-base';
import React, {useCallback, useState} from 'react';
import PageTemplate from 'components/PageTemplate';
import {usePageViewEvent} from 'hooks/usePageViewEvent';
import PageTitle from 'components/PageTitle';
import {ReservationState, ReservationStatus} from 'models/Reservations';
import ConnectedReservationsModule from 'containers/ConnectedReservationsModule';
import {useGetReservations} from 'hooks/useGetReservations';

export enum ReservationsScreenTabs {
  UPCOMING = ReservationState.FUTURE,
  PAST = ReservationState.PAST,
}

const getDisplayText = (tab: ReservationState | ReservationStatus): string => {
  switch (tab) {
    case ReservationState.FUTURE:
      return 'current';
    case ReservationState.PAST:
      return 'past';
    case ReservationStatus.CANCELLED:
      return 'cancelled';
    default:
      return '';
  }
};

const ReservationsScreen: React.FunctionComponent = () => {
  const {trackPageViewEvent} = usePageViewEvent();

  const isLoggedIn = useWidgetState(Selectors.isLoggedInSelector);

  const pageTitle = 'Stays';

  const [activeTab, setActiveTab] = useState<
    ReservationState | ReservationStatus
  >(ReservationState.FUTURE);

  useGetReservations();

  useFocusEffect(trackPageViewEvent);

  const handleTabChange = useCallback((tabName: string) => {
    switch (tabName) {
      case 'current':
        setActiveTab(ReservationState.FUTURE);
        break;
      case 'past':
        setActiveTab(ReservationState.PAST);
        break;
      case 'cancelled':
        setActiveTab(ReservationStatus.CANCELLED);
        break;
    }
  }, []);

  return (
    <PageTemplate>
      {isLoggedIn ? (
        <>
          <PageTitle
            suppressHeaderFooter={false}
            activeTab={getDisplayText(activeTab)}
            title={pageTitle}
            navItems={[{text: 'current'}, {text: 'past'}, {text: 'cancelled'}]}
            updateTab={handleTabChange}
          />

          <StandardContainer>
            <View mt="48px">
              <ConnectedReservationsModule
                isHomeScreen={false}
                activeTab={activeTab}
              />
            </View>
          </StandardContainer>
        </>
      ) : null}
    </PageTemplate>
  );
};

export default ReservationsScreen;
